module.exports = __webpack_public_path__ + "01a652841fcb3916ef8c972aa1292860.ttf";